
import { useStore } from 'vuex'
import { computed, onMounted, reactive, defineComponent } from 'vue'
import Alert from '@/components/elements/Alert.vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import TabSeminar from '@/components/elements/TabSeminar.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import HospitalCassette from '@/components/block/HospitalCassette.vue'
import HospitalCassetteSeminar from '@/components/block/HospitalCassetteSeminar.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useRouter } from 'vue-router'
import NothingArea from '@/components/block/NothingArea.vue'
import BackTo from '@/components/block/BackTo.vue'
import Loader from '@/components/elements/Loader.vue'

export default defineComponent({
  name: 'BookmarkList',

  components: {
    Alert,
    Button,
    HeadingLv1,
    TabSeminar,
    MypageContents,
    HospitalCassette,
    HospitalCassetteSeminar,
    NothingArea,
    BackTo,
    Loader
  },

  setup() {
    const router = useRouter()
    const list = reactive<any>([])
    const list_recommend = reactive<any>([])
    const list_s = reactive<any>([])
    const store = useStore()
    const userInfo = store.state.userInfo
    const state = reactive<any>({
      currentTab: userInfo.member_type === '医学生' ? 0 : 1,
      enableRequest: false,
      s_enableRequest: false,
      hasRequestableHospital: false,
      s_hasRequestableHospital: false,
      isLoading: true,
      s_isLoading: true
    })

    const ckeckedList = reactive<any>([])
    const ckeckedList_s = reactive<any>([])

    const changeCheckbox = (ev: Record<string, boolean>) => {
      if (ev.checked) {
        ckeckedList.push(ev.value)
      } else {
        ckeckedList.splice(ckeckedList.indexOf(ev.value), 1)
      }
    }

    const changeCheckbox_s = (ev: Record<string, boolean>) => {
      if (ev.checked) {
        ckeckedList_s.push(ev.value)
      } else {
        ckeckedList_s.splice(ckeckedList_s.indexOf(ev.value), 1)
      }
    }

    const changeRequestEnable = () => {
      state.enableRequest = state.enableRequest ? false : true
      ckeckedList.splice(0)
    }

    const changeRequestEnable_s = () => {
      state.s_enableRequest = state.s_enableRequest ? false : true
      ckeckedList_s.splice(0)
    }

    const toReqDocs = () => {
      const ids = ckeckedList.join('_')
      const url = `/document_request/${ids}/input`

      router.push({ path: url })
    }

    const toReqDocs_s = () => {
      const ids = ckeckedList_s.join('_')
      const url = `/document_request_latter/${ids}/input`

      router.push({ path: url })
    }

    const tab = computed(() => {
      return [
        {
          label: '病院・初期研修',
          name: 'first'
        },
        {
          label: '専門研修',
          name: 'second'
        }
      ]
    })

    const clickTab = (i: number) => {
      state.currentTab = i
    }

    onMounted(() => {
      const getList = axiosSetting('app', 'page')

      getList
        .get('/api/v1/favorite_list')
        .then((res) => {
          res.data.forEach((item: any) => {
            list.push(item)

            if (item.active_flg === 3 && item.paid_flg === 1) {
              state.hasRequestableHospital = true
            }
          })

          if (res.data.length == 0) {
            getList
              .get('/api/v1/j_search/recommend')
              .then((res_recommend) => {
                res_recommend.data.forEach((item: any) => {
                  list_recommend.push(item)
                })
              })
              .then(() => {
                state.isLoading = false
              })
          } else {
            state.isLoading = false
          }
        })
        .catch(() => {
          state.isLoading = false
        })

      getList
        .get('/api/v1/s_favorite_list')
        .then((res) => {
          res.data.forEach((item: any) => {
            list_s.push(item)

            if (item.active_flg === 3 && item.paid_flg === 1) {
              state.s_hasRequestableHospital = true
            }
          })
          state.s_isLoading = false
        })
        .catch(() => {
          state.s_isLoading = false
        })
    })

    return {
      list,
      list_recommend,
      list_s,
      state,
      tab,
      changeRequestEnable,
      changeRequestEnable_s,
      toReqDocs,
      toReqDocs_s,
      changeCheckbox,
      changeCheckbox_s,
      ckeckedList,
      ckeckedList_s,
      clickTab
    }
  }
})
